import { Badge } from '@flote/ui';
import type { AdminPartitionFulfillmentStatus } from '@flote/contracts/http';

interface PartitionStatusBadgeConfig {
  label: string;
  className: string;
}

const PARTITION_STATUS_CONFIG: Record<AdminPartitionFulfillmentStatus, PartitionStatusBadgeConfig> = {
  pending_offer: {
    label: 'Pending Offer',
    className: 'bg-amber-100 text-amber-800 border-amber-200 hover:bg-amber-100',
  },
  offer_sent: {
    label: 'Offer Sent',
    className: 'bg-blue-100 text-blue-800 border-blue-200 hover:bg-blue-100',
  },
  accepted: {
    label: 'Accepted',
    className: 'bg-emerald-100 text-emerald-800 border-emerald-200 hover:bg-emerald-100',
  },
  declined: {
    label: 'Declined',
    className: 'bg-red-100 text-red-800 border-red-200 hover:bg-red-100',
  },
  expired: {
    label: 'Expired',
    className: 'bg-gray-100 text-gray-800 border-gray-200 hover:bg-gray-100',
  },
  in_transit: {
    label: 'In Transit',
    className: 'bg-cyan-100 text-cyan-800 border-cyan-200 hover:bg-cyan-100',
  },
  shipped: {
    label: 'Shipped',
    className: 'bg-teal-100 text-teal-800 border-teal-200 hover:bg-teal-100',
  },
  assigned: {
    label: 'Assigned',
    className: 'bg-indigo-100 text-indigo-800 border-indigo-200 hover:bg-indigo-100',
  },
  in_progress: {
    label: 'In Progress',
    className: 'bg-violet-100 text-violet-800 border-violet-200 hover:bg-violet-100',
  },
  completed: {
    label: 'Completed',
    className: 'bg-green-100 text-green-800 border-green-200 hover:bg-green-100',
  },
  cancelled: {
    label: 'Cancelled',
    className: 'bg-slate-100 text-slate-800 border-slate-200 hover:bg-slate-100',
  },
};

interface PartitionStatusBadgeProps {
  status: AdminPartitionFulfillmentStatus;
  className?: string;
}

export function PartitionStatusBadge({ status, className }: PartitionStatusBadgeProps) {
  const config = PARTITION_STATUS_CONFIG[status] ?? {
    label: status,
    className: 'bg-gray-100 text-gray-800 border-gray-200',
  };

  return (
    <Badge className={`${config.className} ${className ?? ''}`}>
      {config.label}
    </Badge>
  );
}
